import { toast } from 'sonner'

import { InquiryStageEnum } from '@/gen/cortado/v1/settings_pb'
import { useMoveLeadStage } from '@/stores/pipeline.store'
import { RejectReasonDialog } from '@/components/leads/id/reject-reason-dialog'

interface MarkLeadLostDialogProps {
  inquiryId: string
  open: boolean
  onOpenChange: (open: boolean) => void
  /** Where the user can undo it from, which differs between the callers. */
  description: string
}

/**
 * The job page's reject-reason dialog: asks why the lead was lost (plus
 * optional notes) and saves them with the Rejected stage through the
 * Pipeline's stage move, so the board, its counts and the job follow just as
 * for any other move. Shared by the ⋯ menu's "Mark as lost" and the Lead
 * step's stage picker; cancelling leaves the stage as it was.
 */
export function MarkLeadLostDialog({ inquiryId, open, onOpenChange, description }: MarkLeadLostDialogProps) {
  const { moveLeadStage } = useMoveLeadStage()

  return (
    <RejectReasonDialog
      open={open}
      onOpenChange={onOpenChange}
      inquiryId={inquiryId}
      title="Mark this lead as lost?"
      description={description}
      submitLabel="Mark as lost"
      onReject={(id, reason, notes) => moveLeadStage(id, InquiryStageEnum.INQUIRY_STAGE_REJECTED, reason, notes)}
      onRejected={() => {
        onOpenChange(false)
        toast.success('Marked as lost')
      }}
    />
  )
}
